/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { IComponent, IComponentProps, ICoreContext, ITelemetry, msdyn365Commerce } from '@msdyn365-commerce/core';
//import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import React, { useState } from 'react';

import { InvoiceModel } from '../helpers/invoice-data';
//import { payInvoices } from '../helpers/pay-invoices';
import { IInvoiceErrorState } from '../connelly-invoices-list';

import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';


interface IMakePaymentData {
    invoices: InvoiceModel[];
}

export interface IMakePaymentResources {
    makePaymentButtonText: string;
    makePaymentButtonAriaLabel: string;
}

export interface IMakePaymentProps extends IComponentProps<IMakePaymentData> {
    context: ICoreContext;
    itemKey?: string;
    telemetry: ITelemetry;
    moduleId: string;
    moduleTypeName: string;
    telemetryContent?: ITelemetryContent;
    navigationUrl?: string;
    buttonReferences?: React.RefObject<HTMLButtonElement>;
    resources: IMakePaymentResources;

    onError?(errorState: IInvoiceErrorState, reference?: React.RefObject<HTMLButtonElement>): void;
}

export interface IMakePaymentComponent extends IComponent<IMakePaymentProps> {
}

// const onClick = async (_event: React.MouseEvent<HTMLElement>, props: IMakePaymentProps, setDisabled: (disabled: boolean) => void): Promise<void> => {
//     setDisabled(true);

//     const propagateError = (errorState: IInvoiceErrorState): void => {
//         if (props.onError) {
//             props.onError(errorState, props.buttonReferences);
//         }
//         setDisabled(false);
//     };

//     await payInvoices(props.data.invoices, props.context.actionContext, propagateError);
// };

// const MakePaymentComponentActions = {
//     onClick
// };

/**
 * On Click function.
 * @param input -Make payment props.
 * @param setDisabled -Set Disabled.
 * @returns Make payment component on click.
 */
// const onClickHandler = (input: IMakePaymentProps,
//     setDisabled: React.Dispatch<React.SetStateAction<boolean>>) => async (event: React.MouseEvent<HTMLElement>) => {
//     await MakePaymentComponentActions.onClick(event, input, setDisabled);
// };

const MakePayment: React.FC<IMakePaymentProps> = (input: IMakePaymentProps): JSX.Element => {
    //const { data: { invoices } } = input;
    // const hasInvoices = ArrayExtensions.hasElements(invoices.filter(invoice => invoice.canBePaid));
    // const [disabled, setDisabled] = useState<boolean>(false);


    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);


    

    return (
        <>
            <Button onClick={toggle}>How to make a payment</Button>
            <Modal isOpen={modal} toggle={toggle} className='ab-terms'>
                <ModalHeader toggle={toggle}>How to make a payment</ModalHeader>
                <ModalBody className="inside-xl">
                    <div>
                        <p>To make payments via ACH or WIRE use the bank account and routing information below. 
                            PLEASE NOTE: Separate methods for USA/international dealers and Canadian dealers. </p>
                        <p>To pay by credit card call (425) 775-5416 extension 3.</p>
                        <p><strong>FOR USA AND INTERNATIONAL BASED DEALERS </strong><br/>
                            Account Name: Connelly Skis LLC<br/>
                            Account Type: Checking<br/>
                            Account Number: 01020320675<br/> 
                            Huntington ACH Routing Number: 041215032<br/>  
                            Huntington Wire Routing Number: 044000024<br/>
                            Route Wires to: Huntington National Bank 7 Easton Oval (EA2W47) Columbus, OH 43219<br/>
                            If International, Huntington SWIFT Code: HUNTUS33
                        </p>
                        <p>
                            <strong>FOR CANADA BASED DEALERS </strong><br/>
                            BANK: Royal Bank of Canada<br/>
                            LOCATION: Toronto, Ontario, Canada<br/>
                            SWIFT: ROYCCAT2<br/>
                            CURRENCY TYPE: CAD<br/>
                            ACCOUNT NAME: Huntbk Connelly Skis, LLC<br/>
                            ACCOUNT NUMBER/IBAN: 1000363<br/>
                            TRANSIT NUMBER: 01596<br/>
                            FINANCIAL INSTITTUTION NUMBER: 003 
                        </p>
                    </div>
                </ModalBody>
            </Modal>
        
        </>
    );

};

// @ts-expect-error
export const MakePaymentComponent: React.FunctionComponent<IMakePaymentProps> = msdyn365Commerce.createComponent<IMakePaymentComponent>(
    'MakePayment',
    { component: MakePayment }
);
